<template lang="pug">
  div
    .wrap.static
      .main
        .main-inner
          .title
            h2 このページを表示する権限がありません。

</template>

<script>
  export default {
  }
</script>



// WEBPACK FOOTER //
// src/components/Unauthorized.vue